<script>
  import { PHP } from "../store";

  const shouldHide = () => {
    // This function check if the current page is setting 
    // then return true to hide the activation box intro
    if (!window.URLSearchParams) return false;

    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page");
    
    return page === "best_push_settings";
  };

  let forceClose = shouldHide();
</script>

<style>
  .wrapper {
    margin: 10px 0;
  }
  p {
    color: #333333;
    font-weight: bold;
  }
  a.button {
    margin-left: 10px;
  }
</style>

{#if !$PHP.isActivated && !forceClose}
  <div class="wrapper container is-fluid">
    <div class="notification is-warning">
      <button class="delete" on:click={() => (forceClose = true)} />
      <p>
        For sending notifications and engaging with your customer activate your plugin.
        <a
          class="button is-inverted is-outlined"
          href="/wp-admin/admin.php?page=best_push_settings">
          Click here to activate
        </a>
      </p>
    </div>
  </div>
{/if}
